// extracted by mini-css-extract-plugin
export default {"wrap":"wrap__R3OsZ","button":"button__Ay8pW","paper":"paper__-abjy","menuRoot":"menuRoot__SkZTI"};